<script setup>
import { useHead, useTemplatePage, useRoute, resolveComponent, computed, ref, definePageMeta } from '#imports';
import dataSplitSystem from '~/assets/type_настенный.json';
import dataMultySystem from '~/assets/type_мультисплит-система.json';
import dataKasetSystem from '~/assets/type_кассетный.json';
import dataPotolokSystem from '~/assets/type_потолочный.json';
import dataKolonSystem from '~/assets/type_колонный.json';
import dataKanalSystem from '~/assets/type_канальный.json';

definePageMeta({
    layout: 'catalog',
});

const route = useRoute();
const split = JSON.parse(JSON.stringify(dataSplitSystem));
const multy = JSON.parse(JSON.stringify(dataMultySystem));
const kaset = JSON.parse(JSON.stringify(dataKasetSystem));
const potolok = JSON.parse(JSON.stringify(dataPotolokSystem));
const kolon = JSON.parse(JSON.stringify(dataKolonSystem));
const kanal = JSON.parse(JSON.stringify(dataKanalSystem));

const product = ref('');
const listTitle = ref('');
const linkPrev = ref('');
const breadCrumb = ref('');

const imageProduct = computed(() => {
    let arr = [];

    if (product.value.image.length) {
        arr = product.value.image.map((image) => {
            return `https://air-arts.ru${image}`;
        });
    }

    return arr.length ? arr : 'https://air-arts.ru/450x450.webp';
});

(() => {
    switch (route.params.group) {
        case 'split-system':
            for (
                let i = 0;
                i < split[' Настенные сплит-системы (46 товаров)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === split[' Настенные сплит-системы (46 товаров)'].model[i].link
                ) {
                    product.value
                        = split[' Настенные сплит-системы (46 товаров)'].model[i];
                    listTitle.value
                        = split[' Настенные сплит-системы (46 товаров)'].model[
                            i
                        ].name;
                    breadCrumb.value = 'Кондиционеры настенные (сплит системы)';
                    linkPrev.value = '/catalog/split-system';
                    break;
                }
            }
            break;
        case 'multi-split-system':
            for (
                let i = 0;
                i < multy[' Мультисплит-системы (9 товаров)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === multy[' Мультисплит-системы (9 товаров)'].model[i].link
                ) {
                    product.value
                        = multy[' Мультисплит-системы (9 товаров)'].model[i];
                    listTitle.value
                        = multy[' Мультисплит-системы (9 товаров)'].model[i].name;
                    breadCrumb.value = 'Кондиционеры настенные (мульти-сплит)';
                    linkPrev.value = '/catalog/multi-split-system';
                    break;
                }
            }
            break;
        case 'kassetnie':
            for (
                let i = 0;
                i < kaset[' Кассетные сплит-системы (6 товаров)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === kaset[' Кассетные сплит-системы (6 товаров)'].model[i].link
                ) {
                    product.value
                        = kaset[' Кассетные сплит-системы (6 товаров)'].model[i];
                    listTitle.value
                        = kaset[' Кассетные сплит-системы (6 товаров)'].model[
                            i
                        ].name;
                    breadCrumb.value = 'Кондиционеры кассетные';
                    linkPrev.value = '/catalog/kassetnie';
                    break;
                }
            }
            break;
        case 'napolno-potolochnie':
            for (
                let i = 0;
                i
                < potolok[' Потолочные сплит-системы (5 товаров)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === potolok[' Потолочные сплит-системы (5 товаров)'].model[i]
                        .link
                ) {
                    product.value
                        = potolok[' Потолочные сплит-системы (5 товаров)'].model[
                            i
                        ];
                    listTitle.value
                        = potolok[' Потолочные сплит-системы (5 товаров)'].model[
                            i
                        ].name;
                    breadCrumb.value = 'Кондиционеры напольно-потолочные';
                    linkPrev.value = '/catalog/napolno-potolochnie';
                    break;
                }
            }
            break;
        case 'kolonnie':
            for (
                let i = 0;
                i < kolon[' Колонные сплит-системы (2 товара)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === kolon[' Колонные сплит-системы (2 товара)'].model[i].link
                ) {
                    product.value
                        = kolon[' Колонные сплит-системы (2 товара)'].model[i];
                    listTitle.value
                        = kolon[' Колонные сплит-системы (2 товара)'].model[
                            i
                        ].name;
                    breadCrumb.value = 'Кондиционеры колонные';
                    linkPrev.value = '/catalog/kolonnie';
                    break;
                }
            }
            break;
        case 'kanalnie':
            for (
                let i = 0;
                i < kanal[' Канальные сплит-системы (2 товара)'].model.length;
                i++
            ) {
                if (
                    `/${route.params.name}`
                    === kanal[' Канальные сплит-системы (2 товара)'].model[i].link
                ) {
                    product.value
                        = kanal[' Канальные сплит-системы (2 товара)'].model[i];
                    listTitle.value
                        = kanal[' Канальные сплит-системы (2 товара)'].model[
                            i
                        ].name;
                    breadCrumb.value = 'Кондиционеры канальные';
                    linkPrev.value = '/catalog/kanalnie';
                    break;
                }
            }
            break;
    }
})();

useHead({
    title: `Купить ${listTitle.value} с установкой, Рассрочка, Бесплатная доставка`,
    meta: [
        {
            name: 'description',
            content: (() => {
                return `${product.value.paramsFirst.description[0] ? product.value.paramsFirst.description[0].slice(0, 119) : product.value.paramsFirst.parameter.slice(0, 119)} в Щёлково, Московской области и Москве`;
            })(),
        },
        { property: 'og:url', content: `https://air-arts.ru${route.path}` },
    ],
    link: [
        {
            rel: 'canonical',
            href: `https://air-arts.ru${route.path}`,
        },
    ],
    script: [
        {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
                '@context': 'https://schema.org/',
                '@type': 'Product',
                'name': `${product.value.name}`,
                'category': `Кондиционеры > ${product.value.category}`,
                'manufacturer': 'Dahatsu',
                'image': imageProduct.value,
                'sku': product.value.sku,
                'mpn': product.value.mpn,
                'model': product.value.model,
                'description': `${product.value.paramsFirst.description[0] ? product.value.paramsFirst.description[0] : product.value.paramsFirst.parameter}`,
                'brand': {
                    '@type': 'Brand',
                    'name': 'Dahatsu',
                },
                'offers': {
                    '@type': 'Offer',
                    'url': `https://air-arts.ru${route.path}`,
                    'priceCurrency': 'RUB',
                    'price': `${product.value.price.replace(' ', '')}.00`,
                    'priceValidUntil': '2025-01-02T17:42:19.509Z',
                    'itemCondition': 'https://schema.org/NewCondition',
                    'availability': 'https://schema.org/InStock',
                    'shippingDetails': {
                        '@type': 'OfferShippingDetails',
                        'shippingRate': {
                            '@type': 'MonetaryAmount',
                            'value': '0',
                            'currency': 'RUB',
                        },
                        'shippingDestination': [
                            {
                                '@type': 'DefinedRegion',
                                'addressCountry': 'RU',
                                'addressRegion': [
                                    'Московская область',
                                    'Mосква',
                                    'Щёлково',
                                ],
                            },
                        ],
                        'deliveryTime': {
                            '@type': 'ShippingDeliveryTime',
                            'handlingTime': {
                                '@type': 'QuantitativeValue',
                                'minValue': 0,
                                'maxValue': 1,
                                'unitCode': 'DAY',
                            },
                            'transitTime': {
                                '@type': 'QuantitativeValue',
                                'minValue': 1,
                                'maxValue': 5,
                                'unitCode': 'DAY',
                            },
                        },
                    },
                    'seller': {
                        '@type': 'Organization',
                        'name': 'Air Arts',
                    },
                },
            }),
        },
        {
            type: 'application/ld+json',
            innerHTML: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'WebPage',
                'name': `${product.value.name}`,
                'description': `${product.value.paramsFirst.description[0] ? product.value.paramsFirst.description[0].slice(0, 119) : product.value.paramsFirst.parameter.slice(0, 119)} в Щёлково, Московской области и Москве`,
                'url': `https://air-arts.ru${route.path}`,
                '@id': 'https://air-arts.ru',
                'lastReviewed': '2025-01-02T17:42:19.509Z',
                'mainContentOfPage': {
                    '@type': 'WebPageElement',
                    'cssSelector': '.main',
                    'isAccessibleForFree': true,
                },
                'primaryImageOfPage': {
                    '@type': 'ImageObject',
                    '@id': imageProduct.value[0],
                    'url': imageProduct.value[0],
                    'caption': 'Air Arts',
                },
            }),
        },
    ],
    __dangerouslyDisableSanitizers: ['script'],
});

const templatePage = useTemplatePage();
const Product = resolveComponent(`Product${templatePage.value}`);
</script>

<template>
    <section class="product-page">
        <div
            class="product-page__content"
            itemscope
            itemtype="https://schema.org/Product"
        >
            <BreadCrumbsDesktop
                :data="[
                    { text: 'Главная страница', link: '/' },
                    { text: 'Каталог кондиционеров', link: `/catalog` },
                    { text: `${breadCrumb}`, link: `${linkPrev}` },
                    { text: `${listTitle}`, link: `${route.path}` },
                ]"
            />
            <h1
                class="product-page__title"
                itemprop="name"
            >
                {{ listTitle }}
            </h1>
            <a
                class="schema-org"
                itemprop="url"
                :href="`https://air-arts.ru${route.path}`"
            >{{ `https://air-arts.ru${route.path}` }}</a>
            <component
                :is="Product"
                :product="product"
            />
        </div>
    </section>
</template>

<style lang="less">
.product-page {
    width: 100%;
    min-height: 100vh;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    position: relative;
    margin-bottom: 80px;

    &__content {
        width: 1170px;
        display: flex;
        flex-direction: column;
        position: relative;
    }

    &__title {
        width: 1170px;
        font-family: 'Ruberoid';
        font-size: 64px;
        font-weight: 600;
        line-height: 74px;
        letter-spacing: 0em;
        text-align: left;
        color: #495e4c;
        position: relative;
        margin-bottom: 45px;
    }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
    .product-page {
        min-height: 833px;

        &__content {
            width: 280px;
        }

        &__title {
            width: 280px;
            font-size: 32px;
            line-height: 38px;
            margin-top: 20px;

            &-main {
                font-size: 32px;
                left: 144px;
            }

            &-second {
                font-size: 32px;
                left: 36px;
            }

            &-name {
                font-size: 32px;
                left: 0;
                color: #78c081;
            }
        }
    }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
    .product-page {
        min-height: 866px;

        &__content {
            width: 727px;
        }

        &__title {
            width: 727px;
            font-size: 48px;
            line-height: 48px;

            &-main {
                font-size: 48px;
                left: 214px;
            }

            &-second {
                font-size: 48px;
                left: 53px;
            }

            &-name {
                font-size: 48px;
                left: 0;
            }
        }
    }
}

@media screen and (min-width: 1024px) and (max-width: 1439px) {
    .product-page {
        min-height: 922px;

        &__content {
            width: 944px;
        }

        &__title {
            width: 944px;
            font-size: 55px;
            line-height: 54px;
            margin-top: 20px;

            &-main {
                font-size: 55px;
                left: 464px;
            }

            &-second {
                font-size: 55px;
                left: 279px;
            }

            &-name {
                font-size: 55px;
                left: 0;
            }
        }
    }
}
</style>
